LoadingBarConfig.$inject = ['cfpLoadingBarProvider'];

function LoadingBarConfig(cfpLoadingBarProvider) {
    'use strict';

    cfpLoadingBarProvider.includeBar = true;
    cfpLoadingBarProvider.includeSpinner = false;
}

export default LoadingBarConfig;